<template>
    <v-card class="mb-6 mt-3"
            :style="'border: solid ' + getPeriodColors(openingDiff).deep + ' 1px'">
        <v-app-bar
          dark
          height="auto"
          class="period-toolbar"
          :style="'background-color:' + getPeriodColors(openingDiff).light">
            <div class="d-flex justify-content-between w-100">
                <div
                  class="mt-auto mb-auto cmaj-title align-items-center d-flex justify-content-between w-100">
                    <div class="d-md-flex gap-30">
                        <div :style="'color:' + getPeriodColors(openingDiff).deep">
                            Du
                            <h4 :style="'color:' + getPeriodColors(openingDiff).deep">
                                {{ formatDate(data.valid_from, false) }}</h4>
                        </div>
                        <div :style="'color:' + getPeriodColors(openingDiff).deep">
                            au
                            <h4 :style="'color:' + getPeriodColors(openingDiff).deep">
                                {{ formatDate(data.valid_through, false) }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </v-app-bar>

        <v-card-text style="font-size: 16px">
            <div v-if="data.h24">Ouvert 24h/24 et 7j/7</div>
            <div v-else>
                <div
                  v-for="day in data.opening_days"
                  class="row border-bottom hour-item"
                >
                    <div class="col-3 py-2 align-items-center d-flex">
                        {{ daysOfWeek[day.day_of_week] }}
                    </div>
                    <div class="col py-2">
                        <div v-if="day.closed || (day.closed && day.opening_hours && day.opening_hours.length === 0)">Fermé</div>
                        <div
                          v-else-if="day.opening_hours && day.opening_hours.length > 0 && day.opening_hours[0].open !== null"
                          class="d-flex"
                        >
                            <div class="d-flex align-items-center">
                                <v-chip :color="getPeriodColors(openingDiff).deep"
                                        class="text-white">
                                    {{ formatHour(day.opening_hours[0].open) }}
                                </v-chip>
                                <div class="mr-1 ml-1">/</div>
                                <v-chip :color="getPeriodColors(openingDiff).deep"
                                        class="text-white">
                                    {{ formatHour(day.opening_hours[0].close) }}
                                </v-chip>
                            </div>

                            <div class="d-flex align-items-center"
                                 v-if="day.opening_hours &&
                                       day.opening_hours.length > 1 &&
                                       day.opening_hours[1].open !== null &&
                                       day.opening_hours[1].close !== null">
                                <div class="mr-2 ml-2">–</div>
                                <v-chip :color="getPeriodColors(openingDiff).deep"
                                        class="text-white">
                                    {{ formatHour(day.opening_hours[1].open) }}
                                </v-chip>
                                <div class="mr-1 ml-1">/</div>
                                <v-chip :color="getPeriodColors(openingDiff).deep"
                                        class="text-white">
                                    {{ formatHour(day.opening_hours[1].close) }}
                                </v-chip>
                            </div>
                        </div>
                        <div v-else-if="!day.closed" class="text-success">Ouvert</div>
                        <div v-else>Non renseigné</div>
                    </div>
                </div>
            </div>
            <div class="mt-5 justify-content-between d-flex"
                 v-if="data.description !== null && data.description !== ''">
                <div><b>Complément horaire</b></div>

                <div
                  style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; max-width: 50%">
                    {{ data.description }}
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "OpeningPeriodDiffCard",
    props: ["openingDiff", "data"],
    data() {
        return {
            daysOfWeek: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
        }
    },
    methods: {
        getPeriodColors(openingDiff) {
            if (openingDiff.old === null) {
                return this.addColors
            } else if (openingDiff.new !== null) {
                return this.updateColors
            } else {
                return this.deleteColors
            }
        },
        formatHour(hour) {
            let splited = hour.split(":")
            hour = splited[0] + ":" + splited[1]
            return hour
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>